import { FC } from "react";

import Price from "web/Layout/Common/Price";
import __ from "web/Layout/Translations";

import Title from "web/Components/Common/Title";

import WalletIcon from "web/assets/icons/wallet.svg";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import { getPointsBankName } from "web/utils/page/product/subscription/prepareBenefitsPricesOption";

import { pointsPerMonth, zlotyPerMonth } from "web/constants/benefits";

import { ISubscriptionPointsBank } from "web/types/Subscription";

import { useGetBanksQuery } from "web/features/pointsBank/pointsBankApiSlice";

import EmployeePrice from "../PaymentsShared/EmployeePrice";
import styles from "./paymentsSummaryExtended.scss";

interface IPaymentSummaryExtendedProps {
  title: string;
  employeePrice: string;
  employerPrice: string;
  employeePayUPrice: string;
  employerTaxAmount: string;
  pointsBanks?: ISubscriptionPointsBank[];
  isFetching?: boolean;
}

const PaymentSummaryExtended: FC<IPaymentSummaryExtendedProps> = ({
  title,
  employeePrice = "0",
  employerPrice = "0",
  employeePayUPrice = "0",
  employerTaxAmount = "0",
  pointsBanks,
  isFetching = false,
}) => {
  if (!employeePrice && !employerPrice && !employerTaxAmount) return null;

  const hasEmployerPrice = +employerPrice > 0;
  const hasPointsBanks = isArrayHasItems(pointsBanks);
  const { data: dataBanks } = useGetBanksQuery();
  const { items: availablePointsBanks } = dataBanks || {};

  return (
    <section className={styles.root}>
      <Title
        name={__(title)}
        dataT1="payments_sumary_label_1"
        classes={{ header: styles.title }}
        container="h2"
      />

      <div className={styles.box}>
        {(hasEmployerPrice || hasPointsBanks) && (
          <div className={styles.box__employer}>
            {hasEmployerPrice && (
              <>
                <strong
                  className={styles.label}
                  data-t1="payments_sumary_label_2"
                >
                  {__("Abonamenty opłacane przez pracodawcę")}
                </strong>
                <div className={styles.price}>
                  <div className={styles.icon}>
                    <WalletIcon width={25} />
                  </div>
                  <Price value={employerPrice} currency={__(zlotyPerMonth)} />
                </div>
              </>
            )}

            {hasPointsBanks && (
              <>
                <strong
                  className={styles.label}
                  style={{ marginTop: hasEmployerPrice ? "30px" : "0" }}
                  data-t1="payments_sumary_label_4"
                >
                  {__("Abonamenty opłacane z banków punktów")}
                </strong>
                <div className={styles.bank__list}>
                  {pointsBanks!.map((bank) => {
                    const pointsBankName = getPointsBankName(
                      availablePointsBanks,
                      bank.pointsBankId
                    );

                    return (
                      <div
                        className={styles.bank__item}
                        key={bank.pointsBankId}
                      >
                        <div className={styles.price}>
                          <div className={styles.icon}>
                            <WalletIcon width={25} />
                          </div>
                          <div>
                            <Price
                              value={bank.pointsBankPrice}
                              currency={__(pointsPerMonth)}
                            />
                            <span className={styles.bank__name}>
                              {pointsBankName || bank.name}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        )}

        {+employeePrice || +employerTaxAmount ? (
          <div className={styles.box__employee}>
            <EmployeePrice
              isFetching={isFetching}
              employeePrice={employeePrice}
              employeePayUPrice={employeePayUPrice}
              employerTaxAmount={employerTaxAmount}
            />
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default PaymentSummaryExtended;
